import { render, staticRenderFns } from "./courseAll.vue?vue&type=template&id=37fe0c33&scoped=true&"
import script from "./courseAll.vue?vue&type=script&lang=js&"
export * from "./courseAll.vue?vue&type=script&lang=js&"
import style0 from "./courseAll.vue?vue&type=style&index=0&id=37fe0c33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe0c33",
  null
  
)

export default component.exports